import React from "react";
import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { USERS_TYPE } from "../data/Constants";

const PublicRoute = ({ children }) => {
    const user = useSelector((state) => state.auth.user);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const email = searchParams.get("email");
    const token = searchParams.get("token");

    if (email && token) return children;
    return user ? <Navigate to={user.user_type === USERS_TYPE.USER ? "/dashboard" : "/atp/dashboard"} replace /> : children;
};

export default PublicRoute;
